module.exports = __webpack_public_path__ + "img/acc4.a709448b.png";